import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styles: [`
    :host {
      --bright-blue: oklch(51.01% 0.274 263.83);
      --electric-violet: oklch(53.18% 0.28 296.97);
      --gray-900: oklch(19.37% 0.006 300.98);
      --gray-400: oklch(70.9% 0.015 304.04);

      font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
        Helvetica, Arial, sans-serif;
      box-sizing: border-box;
      display: block;
      width: 100%;
      height: 100%;
    }
  `]
})
export class RootComponent {}
